import React from 'react';
import { Headings } from '@arctheme-components/elements/Headings/Headings';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import { SocialIcons } from '@project-stories/navigation/Footer/FooterSocial/SocialIcons';
import { Image } from "@arctheme-components/elements/Image/Image";
import useMobileBreakpoint from "@mindarc/arctheme-components/frontend/src/hooks/useMobileBreakpoint";

export const Default = ({ links, settings, globals, shop }) => {
  const { links_gap_desktop, links_gap_mobile } = settings;

  const isMobile = useMobileBreakpoint("1024px");

  const links_gap = isMobile ? links_gap_mobile : links_gap_desktop;

  const renderLinkColumn = (link, index) => {
 
    if (link.type === 'list') {
      return (
        <div key={index} className={`footer-links-list py-0 max-w-[${link.settings.text_column_width}px]`}>
          <div className="footer-links-list__container">
            <div className="footer-links-list__title">
              {link.settings.header_text ? (
                <Headings 
                  text={link.settings.header_text} 
                  type={link.settings.header_type || 'h3'}
                />
              ) : (
                <Headings 
                  text={link.settings.link_list.title} 
                  type={link.settings.header_type || 'h3'}
                />
              )}
            </div>
            <div className="footer-links-list__content">
              <ul>
                {link.links.map((listLink, listLinkIndex) => (
                  <li key={listLinkIndex}>
                    <a 
                      href={listLink.url} 
                      className={link.settings.links_type || 'footer-link'}
                      target={link.settings.open_links_new_tab ? "_blank" : "_self"}
                      rel={link.settings.open_links_new_tab ? "noopener noreferrer" : ""}
                    >
                      {listLink.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      );
    } else if (link.type === 'email_subscribe') {
      return (
        <div key={index} className="footer-links-list">
          <div className="collapsible collapsible--desktop-disabled">
            <div className="collapsible__title">
              <Headings 
                text={link.settings.title} 
                type={link.settings.header_type || 'h2'} 
              />
            </div>
            <div className="collapsible__content">
              {link.settings.top_text && (
                <Paragraph 
                  text={link.settings.top_text} 
                  type={link.settings.top_text_type || 'b3'}
                />
              )}
              
              {link.settings.show_social_icons && globals?.social_links && (
                <div className="social-links mb-4">
                  <SocialIcons list_links={globals.social_links} />
                </div>
              )}

              {link.settings.content && (
                <Paragraph 
                  text={link.settings.content} 
                  type={link.settings.content_type || 'b2'} 
                />
              )}

              {link.settings.newsletter_type === 'api' && (
                <div className="mt-3">
                  {/* <FooterSubscribe globals={globals} settings={settings} list_links={links} /> */}
                  {link.settings.sign_up_message && (
                    <div className={`mt-2 ${link.settings.sign_up_message_type || 'disclaimer'}`}>
                      <Paragraph 
                        text={link.settings.sign_up_message} 
                        type={link.settings.sign_up_message_type || 'disclaimer'}
                      />
                    </div>
                  )}
                </div>
              )}

              {link.settings.newsletter_type === 'embed' && link.settings.newsletter_embed_src && (
                <div className="footer-subscribe__embed mt-3" dangerouslySetInnerHTML={{ __html: link.settings.newsletter_embed_src }} />
              )}

              {link.settings.contact_info && (
                <div className={`mt-4 ${link.settings.contact_info_type || 'contact-text'}`} dangerouslySetInnerHTML={{ __html: link.settings.contact_info }} />
              )}
            </div>
          </div>
        </div>
      );
    }

    else if (link.type === 'main_content') {
      return (
        <div key={index} className={`footer-links-list footer-main-content max-w-[${link.settings.text_column_width}px]`}>
          <div className="footer-main-content__container">
            <div className="footer-main-content__title">
              <div className={link.settings.header_type || 'h2'}>
                {link.settings.title}
              </div> 
            </div>

            <div className={`footer-main-content__content pt-[${link.settings.content_top_padding}px]`} >
              {link.settings.content && (
                <Paragraph 
                  text={link.settings.content}
                  maxChars={0}
                  type={link.settings.content_type || 'b2'} 
                />
              )}
            </div>

            <div className="footer-main-content__images"> 
                { link.settings.image_1 &&  <Image imageUrl={link.settings.image_1} alt={link.settings.image_1.alt} /> }
                { link.settings.image_2 &&  <Image imageUrl={link.settings.image_2} alt={link.settings.image_2.alt} /> }
                { link.settings.image_3 &&  <Image imageUrl={link.settings.image_3} alt={link.settings.image_3.alt} /> }
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="footer-links w-full">
      <div className={`footer-links container flex flex-col lg:flex-row gap-[${links_gap}px]`}>
        {links.map((link, index) => renderLinkColumn(link, index))}
      </div>
    </div>
  );
};
